import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/routes")({
  component: Outlet,
});
